<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="title" [RouteStack]="RouteStack" />

  <div>
    <div class="row default-spacing-title agrupameno-topico-domge" style="margin: 0">
      <div class="col-lg-6 col-12 img-header-historia"
        style="background-image: url('images/impressao-historia-jornal-header.jpg');">
        <div>
        </div>
      </div>

      <div class="col-lg-6 col-12">
        <h2>Seja bem-vindo ao Jornal Minas Gerais!</h2>
        <p>Somos o Diário Oficial do Estado, responsável por divulgar informações oficiais para toda a população mineira.</p>
        <p>Neste espaço, você conhecerá a história do jornal, a missão e o papel fundamental na comunicação dos atos do Governo do Estado. Nosso compromisso é dar acesso às informações de interesse público de forma clara e facilitada, sempre pautados pela ética e transparência.</p>
        <p style="font-size: larger;">Saiba mais como o Minas Gerais conecta você às decisões do Estado!</p>
      </div>
    </div>

    <div style="background-color: var(--tom-2-informativo);">
      <div class="row default-spacing-title" style="margin: 0">
        @for(conceito of dados?.conceitos; track $index){
        <div class="col-lg-4 col-12 group-conceito">
          <div class="card-conceito">
            <h5>{{conceito['Titulo']}}</h5>
            <div class="icone-conceito" *ngIf="conceito['Titulo'] === 'Missão'">
              <svg width="42" height="42" viewBox="0 0 42 42" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.8333 37.5C30.0381 37.5 37.5 30.0381 37.5 20.8333C37.5 11.6286 30.0381 4.16667 20.8333 4.16667C11.6286 4.16667 4.16667 11.6286 4.16667 20.8333C4.16667 30.0381 11.6286 37.5 20.8333 37.5ZM20.8333 41.6667C9.3274 41.6667 0 32.3392 0 20.8333C0 9.3274 9.3274 0 20.8333 0C32.3392 0 41.6667 9.3274 41.6667 20.8333C41.6667 32.3392 32.3392 41.6667 20.8333 41.6667ZM20.8333 29.1667C25.4356 29.1667 29.1667 25.4356 29.1667 20.8333C29.1667 16.231 25.4356 12.5 20.8333 12.5C16.231 12.5 12.5 16.231 12.5 20.8333C12.5 25.4356 16.231 29.1667 20.8333 29.1667ZM20.8333 33.3333C13.9298 33.3333 8.33333 27.7369 8.33333 20.8333C8.33333 13.9298 13.9298 8.33333 20.8333 8.33333C27.7369 8.33333 33.3333 13.9298 33.3333 20.8333C33.3333 27.7369 27.7369 33.3333 20.8333 33.3333ZM20.8333 25C18.5321 25 16.6667 23.1346 16.6667 20.8333C16.6667 18.5321 18.5321 16.6667 20.8333 16.6667C23.1346 16.6667 25 18.5321 25 20.8333C25 23.1346 23.1346 25 20.8333 25Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div class="icone-conceito" *ngIf="conceito['Titulo'] === 'Visão'">
              <svg width="46" height="38" viewBox="0 0 46 38" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M23.0008 0.25C34.2343 0.25 43.5802 8.33283 45.5395 19C43.5802 29.6671 34.2343 37.75 23.0008 37.75C11.7671 37.75 2.42131 29.6671 0.461914 19C2.42131 8.33283 11.7671 0.25 23.0008 0.25ZM23.0008 33.5833C31.825 33.5833 39.3758 27.4417 41.287 19C39.3758 10.5584 31.825 4.41667 23.0008 4.41667C14.1764 4.41667 6.62562 10.5584 4.71429 19C6.62562 27.4417 14.1764 33.5833 23.0008 33.5833ZM23.0008 28.375C17.823 28.375 13.6257 24.1777 13.6257 19C13.6257 13.8223 17.823 9.625 23.0008 9.625C28.1783 9.625 32.3758 13.8223 32.3758 19C32.3758 24.1777 28.1783 28.375 23.0008 28.375ZM23.0008 24.2083C25.8772 24.2083 28.2091 21.8765 28.2091 19C28.2091 16.1235 25.8772 13.7917 23.0008 13.7917C20.1243 13.7917 17.7924 16.1235 17.7924 19C17.7924 21.8765 20.1243 24.2083 23.0008 24.2083Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div class="icone-conceito" *ngIf="conceito['Titulo'] === 'Valores'">
              <svg width="42" height="42" viewBox="0 0 42 42" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.0101 41.8389C9.50417 41.8389 0.176758 32.5116 0.176758 21.0056C0.176758 9.49976 9.50417 0.172363 21.0101 0.172363C32.516 0.172363 41.8435 9.49976 41.8435 21.0056C41.8435 32.5116 32.516 41.8389 21.0101 41.8389ZM21.0101 37.6723C30.2149 37.6723 37.6768 30.2104 37.6768 21.0056C37.6768 11.8009 30.2149 4.33903 21.0101 4.33903C11.8053 4.33903 4.34342 11.8009 4.34342 21.0056C4.34342 30.2104 11.8053 37.6723 21.0101 37.6723ZM14.7601 12.6724H27.2601L32.4685 19.9639L21.0085 31.4223L9.55176 19.9639L14.7601 12.6724ZM16.906 16.8389L14.9893 19.5264L21.0085 25.5473L27.031 19.5264L25.1143 16.8389H16.906Z"
                  fill="currentColor" />
              </svg>
            </div>
            <p style="margin-top: 1rem;">{{conceito['Descricao']}}</p>
          </div>
        </div>
        }
      </div>
    </div>

    <div>
      <h3 class="default-spacing-title">A história na linha do tempo</h3>

      <lib-segov-sigepo-timeline-carousel
      [numeroItemsPorPagina]="numeroItensPagina"
      [items]="timelineItems"/>
    </div>

    <div class="default-spacing-title">
      <div id="headersidemenuhistoria" style="background-color: var(--tom-2-informativo); padding: 2rem">
        <h1 style="margin: 0; color: var(--text-geral-fundo-escuro);">Conheça a história do Diário</h1>
      </div>
      <lib-segov-sigepo-side-menu-with-body
      [menuArticleSelectedItemOnStartInput]="finalizouNovaPesquisa"
      (topicoOutput)="scrollToId($event)"
      [menusWithArticle]="menuHistoriaDiario" />
    </div>

    <div style="background-color: var(--tom-1-informativo);">
      <div class="row" style="margin: 0;">
        <div class="col-lg-6 col-12">
          <div class="coluna-esquerda">
            <h2 style="color: white; font-weight: 600; margin-bottom: 1rem;">Reportagens Históricas</h2>
            <p>Vários fatos e notícias foram destaque no Diário Oficial ao longo dos anos. Acesse nosso banco de
              notícias e conheça um pouco mais os fatos que marcaram época.</p>
            <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [type]="'button'"
              [width]="'260px'"
              (click)="goToReportagensIconicas()" (keyup.enter)="goToReportagensIconicas()"
              [customStyle]="'border-radius: 5px; background-color: var(--tom-bg-escuro-portal); color: var(--text-geral-fundo-escuro);'">
              Banco de notícias
            </lib-segov-sigepo-rounded-button>
          </div>
        </div>
        <div class="col-lg-6 col-12 img-domge-foco"
          style="background-image: url('images/impressao-historia-jornal-domge-foco.jpg');">
        </div>
      </div>
    </div>

    <div class="default-spacing-title mt-xl-3 mt-1">
      <h2 style="font-weight: 600; margin-bottom: 1rem;">Expediente</h2>

      <div class="card-expediente">
        <h3 style="text-align: center; font-weight: 600;">MINAS GERAIS</h3>
        <h3 style="text-align: center; font-weight: 600;">Diário Oficial Eletrônico</h3>
        <h3 class="governo-estado-subtitle" style="text-align: center;">Governo do Estado de Minas Gerais</h3>

        <div class="row mt-5 px-lg-5">
          <div class="col-lg-6 col-12 mb-3">
            @for(expediente of obterColunaExpediente(1); track $index) {
              <p style="margin-bottom: 2px;">{{expediente.dirigente['Cargo']}}</p>
              <p style="font-weight: 500; font-size: 18px; margin-bottom: 1rem;">{{expediente.dirigente['Nome']}}</p>
            }
          </div>
          <div class="col-lg-6 col-12 mb-3">
            @for(expediente of obterColunaExpediente(0); track $index) {
              <p style="margin-bottom: 2px;">{{expediente.dirigente['Cargo']}}</p>
              <p style="font-weight: 500; font-size: 18px; margin-bottom: 1rem;">{{expediente.dirigente['Nome']}}</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</app-segov-sigepo-portal-body>
